import _pick from 'lodash/pick';

export function buildWorkspacePersonaFromUserPersona(userPersona) {
  const workspacePersona = _pick(userPersona, [
    'company',
    'company_size',
    'company_industry',
    'use_case_plan',
    'use_case_plan_persona',
  ]);

  return Object.fromEntries(
    Object.entries(workspacePersona).filter(([, value]) => Boolean(value))
  );
}
